export const environment = {
  production: false,
  apiUrl: 'https://localhost:9001/api',
  googleApiKey: 'AIzaSyAdKYTXOga8LVv8oX-NSFG8S5hjunu7_qg',
  code: '',
  bugsnagApiKey: '7151d1000f663b521b4d5df2f0f86ae4',
  bugsnagEnv: 'Development',
  isOffline: "false",
  offlineRegisterFormLink: '',
};
